import React from "react";
import { TimeSheetStatus } from "./timesheetConstants";
import "./TimeSheets.css";

const badgeClass = (status) => {
  switch (status) {
    case TimeSheetStatus.Draft:
      return "ts-badge ts-badge--draft";
    case TimeSheetStatus.Submitted:
      return "ts-badge ts-badge--submitted";
    case TimeSheetStatus.Approved:
      return "ts-badge ts-badge--approved";
    case TimeSheetStatus.Rejected:
      return "ts-badge ts-badge--rejected";
    case TimeSheetStatus.Returned:
      return "ts-badge ts-badge--returned";
    default:
      return "ts-badge ts-badge--draft";
  }
};

const TimeSheetStatusBadge = ({ status, label }) => (
  <span className={badgeClass(status)}>{label}</span>
);

export default TimeSheetStatusBadge;
